import { IDropdownData } from 'models/common';
import * as c from 'models/constants';
import * as i18n from 'i18next';

export function getMagazinePageSectionTypes(): IDropdownData[] {
	const sections: IDropdownData[] = [];

	sections.push({ key: c.MAGAZINE_PAGE_SECTION_TYPE_13, image: 'type13.png', value: 'Hero banner' });
	sections.push({ key: c.MAGAZINE_PAGE_SECTION_TYPE_14, image: 'type14.png', value: 'Magazine tags' });
	sections.push({ key: c.MAGAZINE_PAGE_SECTION_TYPE_15, image: 'type15.png', value: 'Search bar' });
	// sections.push({ key: c.MAGAZINE_PAGE_SECTION_TYPE_1, image: 'type1.png', value: 'Magazine_Section_Type1_Title' });
	sections.push({ key: c.MAGAZINE_PAGE_SECTION_TYPE_2, image: 'type2.png', value: 'Magazine_Section_Type2_Title' });
	// sections.push({ key: c.MAGAZINE_PAGE_SECTION_TYPE_3, image: 'type3.png', value: 'Magazine_Section_Type3_Title' });
	// sections.push({ key: c.MAGAZINE_PAGE_SECTION_TYPE_4, image: 'type4.png', value: 'Magazine_Section_Type4_Title' });
	sections.push({ key: c.MAGAZINE_PAGE_SECTION_TYPE_5, image: 'type5.png', value: 'Magazine_Section_Type5_Title' });
	sections.push({ key: c.MAGAZINE_PAGE_SECTION_TYPE_6, image: 'type6.svg', value: 'Magazine_Section_Type6_Title' });
	// sections.push({ key: c.MAGAZINE_PAGE_SECTION_TYPE_7, image: 'type7.png', value: 'Magazine_Section_Type7_Title' });
	sections.push({ key: c.MAGAZINE_PAGE_SECTION_TYPE_8, image: 'type8.png', value: 'Magazine_Section_Type8_Title' });
	// sections.push({ key: c.MAGAZINE_PAGE_SECTION_TYPE_9, image: 'type9.png', value: 'Magazine_Section_Type9_Title' });
	//sections.push({ key: c.MAGAZINE_PAGE_SECTION_TYPE_10, value: 'type7.png' });
	sections.push({ key: c.MAGAZINE_PAGE_SECTION_TYPE_11, image: 'type11.png', value: 'Magazine_Section_Type11_Title' });
	sections.push({ key: c.MAGAZINE_PAGE_SECTION_TYPE_12, image: 'type12.svg', value: 'Magazine_Section_Type12_Title' });

	return sections;
}

export function getPortalPageSectionTypes(): IDropdownData[] {
	const sections: IDropdownData[] = [];

	//sections.push({ key: c.LANDING_PAGE_SECTION_TYPE_1, value: '1 full size' });
	// sections.push({ key: c.PORTAL_PAGE_SECTION_TYPE_2, value: '3 Horizontal' });
	// sections.push({ key: c.PORTAL_PAGE_SECTION_TYPE_3, value: 'Get Started' });
	// sections.push({ key: c.PORTAL_PAGE_SECTION_TYPE_4, value: '9 Horizontal slider' });
	sections.push({
		key: c.PORTAL_PAGE_SECTION_TYPE_5,
		value: i18n.t('PortalPage_Section_Manage_SectionTitle_HeroBanner'),
	});
	// sections.push({ key: c.PORTAL_PAGE_SECTION_TYPE_6, value: 'Community' });
	sections.push({
		key: c.PORTAL_PAGE_SECTION_TYPE_7,
		value: i18n.t('PortalPage_Section_Manage_SectionTitle_ProductList'),
	});
	// sections.push({ key: c.PORTAL_PAGE_SECTION_TYPE_8, value: 'Title' });
	sections.push({ key: c.PORTAL_PAGE_SECTION_TYPE_9, value: i18n.t('BSPortal_Common_Magazine') });
	// sections.push({ key: c.PORTAL_PAGE_SECTION_TYPE_10, value: 'UserFeed' });
	sections.push({
		key: c.PORTAL_PAGE_SECTION_TYPE_11,
		value: i18n.t('PortalPage_Section_Manage_SectionTitle_ShopByCategory'),
	});
	sections.push({
		key: c.PORTAL_PAGE_SECTION_TYPE_12,
		value: i18n.t('PortalPage_Section_Manage_SectionTitle_PopularBrands'),
	});

	return sections;
}

export function getMenuTypes(): IDropdownData[] {
	const sections: IDropdownData[] = [];

	// sections.push({ key: c.MENU_TYPE_PAGE, value: 'Page' });
	sections.push({ key: 'MenuTypeLink', value: 'Page' }); // admin can choose to add a link to existing real magazine or portal page = MENU_TYPE_PAGE
	sections.push({ key: c.MENU_TYPE_CATEGORY, value: 'Category' });

	return sections;
}
